module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"YEARLING":"Yearling","YEAR2":"2-years-old","YEAR3":"3-years-old","CAE":"HIT","MARE":"Broodmare","MAIDEN":"Maiden","STORE2":"2YO Store","STORE3":"3YO Store","STALLION":"Stallion","STALLION_PART":"Stallion share","FOAL":"Foal","BREEDING_RIGHT":"Breeding right"}}')
  delete Component.options._Ctor
}
